import { Button, JoonUIColor, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import PasscodeInput from "../../../../../components/passcodeInput/PasscodeInput"
import useMultiInputFocus from "../../../../../hooks/useMultiInputFocus"
import { ParentPasscodeStep } from "../../../../../types"
import { useParentPasscodeModalStore } from "../useParentPasscodeModalStore"

const ConfirmSetPasscode = () => {
  const {
    passcode,
    confirmPasscode,
    setConfirmPasscode,
    showError,
    setShowError,
    setStep,
    setHasParentAppRequirement,
    setHasParentPanelRequirement,
  } = useParentPasscodeModalStore()
  const {
    ref: passcodeInputRef,
    focusFirstInput,
    clearInputs,
  } = useMultiInputFocus({})
  const { t } = useTranslation()

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (passcode === confirmPasscode) {
      setShowError(false)
      setStep(ParentPasscodeStep.REQUIREMENTS)
      setHasParentAppRequirement(true)
      setHasParentPanelRequirement(true)
    } else {
      setConfirmPasscode("")
      focusFirstInput()
      clearInputs()
      setShowError(true)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Typography variant="bodyBold">
            {t("PPC_CONFIRM_SET_TITLE")}
          </Typography>
          <Typography variant="bodySmall">
            {t("PPC_CHANGE_LATER_DESC")}
          </Typography>
        </div>

        <PasscodeInput
          value={confirmPasscode}
          setValue={setConfirmPasscode}
          ref={passcodeInputRef}
        />

        <Button
          text={t("PPC_NEXT")}
          type="submit"
          fullWidth
          disabled={confirmPasscode.length !== 4}
        />
        {showError && (
          <Typography variant="bodySmall" color={JoonUIColor.semantic.alert}>
            {t("PPC_ERR_NO_MATCH")}
          </Typography>
        )}
      </div>
    </form>
  )
}

export default ConfirmSetPasscode
